import QuoteFunnel from "./QuoteFunnel";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden" style={{
      background: `linear-gradient(135deg, hsl(270 60% 95%) 0%, hsl(210 40% 98%) 40%, hsl(270 50% 93%) 70%, hsl(210 40% 98%) 100%)`
    }}>
      {/* Gradient mesh orbs */}
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full opacity-20 blur-3xl" style={{
        background: `radial-gradient(circle, hsl(270 70% 55%), transparent 70%)`
      }} />
      <div className="absolute -bottom-24 right-0 w-[500px] h-[500px] rounded-full opacity-15 blur-3xl" style={{
        background: `radial-gradient(circle, hsl(270 60% 60%), transparent 70%)`
      }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-[0.07] blur-3xl" style={{
        background: `radial-gradient(circle, hsl(270 70% 45%), transparent 60%)`
      }} />

      {/* Geometric mesh pattern */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: `
          linear-gradient(30deg, hsl(270 70% 40%) 12%, transparent 12.5%, transparent 87%, hsl(270 70% 40%) 87.5%, hsl(270 70% 40%)),
          linear-gradient(150deg, hsl(270 70% 40%) 12%, transparent 12.5%, transparent 87%, hsl(270 70% 40%) 87.5%, hsl(270 70% 40%)),
          linear-gradient(30deg, hsl(270 70% 40%) 12%, transparent 12.5%, transparent 87%, hsl(270 70% 40%) 87.5%, hsl(270 70% 40%)),
          linear-gradient(150deg, hsl(270 70% 40%) 12%, transparent 12.5%, transparent 87%, hsl(270 70% 40%) 87.5%, hsl(270 70% 40%)),
          linear-gradient(60deg, hsl(270 60% 50% / 0.5) 25%, transparent 25.5%, transparent 75%, hsl(270 60% 50% / 0.5) 75%, hsl(270 60% 50% / 0.5)),
          linear-gradient(60deg, hsl(270 60% 50% / 0.5) 25%, transparent 25.5%, transparent 75%, hsl(270 60% 50% / 0.5) 75%, hsl(270 60% 50% / 0.5))
        `,
        backgroundSize: '80px 140px',
        backgroundPosition: '0 0, 0 0, 40px 70px, 40px 70px, 0 0, 40px 70px'
      }} />

      <div className="container relative py-16 md:py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text */}
          <div className="text-foreground">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary/10 border border-primary/15 rounded-full mb-6">
              <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
              <span className="text-xs font-medium text-primary">Compare 30+ Carriers in 3 Minutes</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-[3.5rem] font-bold leading-[1.1] mb-5">
              Arizona's Independent Choice for{" "}
              <span className="text-primary">Business & Family Insurance</span>
            </h1>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-prose-wide mb-8">
              Mom & Pop Insurance shops the entire market — not just one carrier. 
              Get personalized quotes from 30+ top-rated insurers, with guidance from a 
              Phoenix-based broker who knows your community.
            </p>
            <div className="flex flex-wrap gap-6 text-sm text-muted-foreground">
              <span className="flex items-center gap-1.5">✓ Independent & Unbiased</span>
              <span className="flex items-center gap-1.5">✓ Licensed in 6 States</span>
              <span className="flex items-center gap-1.5">✓ Same-Day Quotes</span>
            </div>
          </div>

          {/* Quote Funnel */}
          <div>
            <QuoteFunnel />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
